export default {
  meta: {
    title: '竞品分布地图',
    url: '/selection/industry', // 埋点用，记录所属模块
    // eventId: '50f52283-51e4-4c36-809d-c8e14b5d6634'
  },
};
